
export function getJobDayStatus(crewAssignments) {

    let status = 'unknown'

    // time ticket status
    let finishCount = 0
    let preliminaryApprovalCount = 0
    let finalApprovalCount = 0
    let isPaidCount = 0

    crewAssignments.forEach(assignment => {
        if(!assignment.endTime) {
            finishCount++
        } else if(!assignment.preliminaryApproval) { 
            preliminaryApprovalCount++
        } else if(!assignment.finalApproval) {
            finalApprovalCount++
        } else if(!assignment.isPaid) {
            isPaidCount++
        }
    })
    if(crewAssignments.length == 0) { status = 'unknown'}
    else if(finishCount > 0){ status = 'finish'}
    else if(preliminaryApprovalCount > 0){ status = 'preliminary'}
    else if(finalApprovalCount > 0){ status = 'final'}
    else if(isPaidCount > 0 ) { status = 'payment'}
    else { status = 'paid'}
    return status
}